import { UpdateCommunityComponent } from './update-community/update-community.component'
import { CreateCommunityComponent } from './create-community/create-community.component'
import { CommunitiesComponent } from './communities.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const communitiesRoutes: Routes = [
  {
    path: 'admin/communities',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'SYSTEM_MANAGEMENT_PANEL',
        redirectTo: '/',
      },
    },
    children: [
      {
        path: '',
        component: CommunitiesComponent,
        data: {
          permissions: {
            only: 'SYSTEM_MANAGEMENT_PANEL',
            redirectTo: '/',
          },
        },
      },
      {
        path: 'create',
        component: CreateCommunityComponent,
        data: {
          permissions: {
            only: 'SYSTEM_MANAGEMENT_PANEL',
            redirectTo: '/',
          },
        },
      },
      {
        path: ':id/update',
        component: UpdateCommunityComponent,
        data: {
          permissions: {
            only: 'SYSTEM_MANAGEMENT_PANEL',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
